import * as tracking from 'dibs-tracking';

export const trackNewSellerPillHover = () => {
    tracking.trackEvent({
        action: 'new seller pill tooltip displayed',
        category: 'product',
        event: 'e_ga_event',
        label: 'pdp',
    });
};
